var _a;
import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
import { passwordSchema } from './common';
import { createAuthFormHook } from './createAuthFormHook';
export var ENewPasswordFormField;
(function (ENewPasswordFormField) {
    ENewPasswordFormField["NEW_PASSWORD"] = "newPassword";
    ENewPasswordFormField["REPEAT_NEW_PASSWORD"] = "repeatNewPassword";
})(ENewPasswordFormField || (ENewPasswordFormField = {}));
var required = fieldValidationMessageIds.required, passwordEntriesDoNotMatch = fieldValidationMessageIds.passwordEntriesDoNotMatch;
export var newPasswordFormSchema = yup.object((_a = {},
    _a[ENewPasswordFormField.NEW_PASSWORD] = passwordSchema,
    _a[ENewPasswordFormField.REPEAT_NEW_PASSWORD] = yup
        .string()
        .required(required)
        .oneOf([yup.ref(ENewPasswordFormField.NEW_PASSWORD), ''], passwordEntriesDoNotMatch),
    _a));
var useCreateNewPassword = createAuthFormHook(newPasswordFormSchema);
export var useCreateNewPasswordForm = function (onSubmit, useFormProps) {
    return useCreateNewPassword(function (_a) {
        var _b = ENewPasswordFormField.NEW_PASSWORD, password = _a[_b];
        return onSubmit({ password: password });
    }, useFormProps);
};
